
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weight-loss",
      function () {
        return require("private-next-pages/weight-loss.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weight-loss"])
      });
    }
  